export type LegacyFeedbackModalProps = {
  teamId?: string;
  memberId?: string;
  actId?: string;
  dataFrom?: string;
  goalId?: string;
  metricId?: string;
  analyticName?: string;
  location?: string;
}

export enum FeedbackObjectType {
  Objective = 'objective',
  KR = 'kr',
  Action = 'action',
  User = 'user'
}

export type FeedbackModalProps = {
  ObjectType: string;
  ObjectId: string;
  location?: string;
}